import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "duplicate",
  "use": "duplicate-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"duplicate\">\n <path d=\"m14 5h-8c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zm0 2v14h-8v-14zm-7-6h11c1.1 0 2 0.9 2 2v17h-2v-17h-11z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol